var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sharing-packets",class:_vm.state === true ? 'on' : ''})
}
var staticRenderFns = []

export { render, staticRenderFns }